import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { LightNode } from '../../types';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import {
  DEFAULT_LIGHT_COLOR,
  getLightHexColor,
  getLightLabel,
  isLightColor,
} from '../../config/lightPresets';
import { CardShell } from '../CardShell';

export const LightNodeView = memo(function LightNodeView({ data }: NodeProps<LightNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  const color = isLightColor(data.color) ? data.color : DEFAULT_LIGHT_COLOR;

  return (
    <CardShell
      kind="light"
      accent="yellow"
      title={getNodeDisplayLabel('light', displayLanguage)}
      summary={getLightLabel(color, displayLanguage)}
      summaryColor={getLightHexColor(color)}
    >
      <Handle type="target" position={Position.Left} className="!bg-yellow-500" />
      <Handle type="source" position={Position.Right} className="!bg-yellow-500" />
    </CardShell>
  );
});
